import type { Config } from '@packages/config';
import { useDeviceType } from '@packages/shared';
import { useConfig } from '@packages/utilities';

/**
 * Method to return a string to determine a breakpoint depending akamai image-template.
 * Template strings can be configured in the next-configuration.
 * Depending on the current breakpoint -> the corresponding format is choosen.
 *
 * You can specify a "type", to choose where your image is placed (controls which template is choosen).
 *
 * @param type - constant 'gallery' or 'zoom' or 'thumbnail', where to use your product image
 * @returns the akamai-template suffix string to append to a img-src.
 */
export function useResponsiveAkamaiTemplate(type: keyof Config['product']['imageFormat']): string {
  const { isDesktop, isTablet } = useDeviceType();
  const {
    product: { imageFormat },
  } = useConfig();

  const format = imageFormat[type];

  if (isDesktop) {
    return `$${format.desktop}$`;
  }
  if (isTablet) {
    return `$${format.tablet}$`;
  }
  return `$${format.mobile}$`;
}
